<template>
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        Danh sách sự kiện
      </div>
      <div class="card-title">
        <el-button class="font-weight-bold font-size-3 btn btn-success" @click="exportExcel">Export</el-button>
      </div>
    </div>
    <div class="card-body">
      <div class="example mb-10">
        <div class="row">
          <div class="form-group col-md-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text line-height-0 py-0">
                  <span class="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                              fill="#000000" fill-rule="nonzero"
                              opacity="0.3"></path>
                        <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                              fill="#000000"
                              fill-rule="nonzero"></path>
                      </g>
                    </svg>
                    <!--end::Svg Icon-->
                  </span>
                </span>
              </div>
              <input type="text" class="form-control" placeholder="Mã, tên, sdt, email" v-model="keyword" aria-describedby="basic-addon2" @keyup="handleFormSearch($event)">
            </div>
          </div>
        </div>
        <div class="example-preview table-responsive">
          <table class="table table-bordered m-0 table-vertical-center">
            <thead>
              <tr>
                <th class="event-title">Mã nhân sự</th>
                <th class="event-title">Tên</th>
                <th class="event-title">Số điện thoại</th>
                <th class="event-title">Email</th>
                <th class="event-title">Loại ghế</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="event in events">
                <td>{{ event.user_id + 100000 }}</td>
                <td>{{ event.user.name }}</td>
                <td>{{ event.user.phone }}</td>
                <td>{{ event.user.email }}</td>
                <td>{{ event.chair.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="edu-paginate mx-auto text-center">
      <paginate
              v-model="page"
              :page-count="last_page"
              :page-range="3"
              :margin-pages="1"
              :click-handler="clickCallback"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
    import Swal from "sweetalert2";
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
    import DatePicker from "vue2-datepicker";
    import 'vue2-datepicker/index.css';
    import '@/assets/sass/custom/custom_event.scss';
    import {GET_USER_SEATING, EXPORT_USER_SEATING} from "../../../core/services/store/event/event.module";
    import {ExportExcelModel} from "@/view/pages/backoffice/managements/model/ManagementKpiModel";
    import { exportExcel } from "@/core/filters";

    export default {
        components: {
            DatePicker,
            Multiselect
        },
        name: "Event-Seating",
        data() {
            return {
                areas: [],
                centers: [],
                formSearch: {
                    title: '',
                    area: '',
                    center: '',
                    startDate: '',
                    endDate: ''
                },
                events: [],
                page: 1,
                last_page: 1,
                keyword: '',
            }
        },
        mounted() {
            this.getListEvents();
             this.$store.dispatch(SET_BREADCRUMB, [
                  {title: "Quản lý sự kiện", route: 'event-list'},
                  {title: "Danh sách sự kiện"}
             ]);
        },
        methods : {
            handleFormSearch() {
                this.page = 1
                this.getListEvents()
            },
            getListEvents() {
                this.$store.dispatch(GET_USER_SEATING, {
                    page: this.page,
                    keyword: this.keyword,
                }).then((res) => {
                    this.events = res.data.data
                    this.last_page = res.data.last_page
                });
            },
            clickCallback(obj) {
                this.page = obj
                this.getListEvents()
            },
            exportExcel() {
                this.is_export_excel = true
                const HEADER_ROW_EXPORT = [
                    {
                        key: 'stt',
                        value: 'STT',
                    },
                    {
                        key: 'user_id',
                        value: 'Mã nhân sự',
                    },
                    {
                        key: 'name',
                        value: 'Họ và tên',
                    },
                    {
                        key: 'phone',
                        value: 'Số điện thoại',
                    },
                    {
                        key: 'email',
                        value: 'Email',
                    },
                    {
                        key: 'department_name',
                        value: 'Phòng ban',
                    },
                    {
                        key: 'branch_name',
                        value: 'Văn phòng',
                    },
                    {
                        key: 'area_name',
                        value: 'Khu vực',
                    },
                    {
                        key: 'account_name',
                        value: 'Khu vực',
                    },
                    {
                        key: 'business_level_name',
                        value: 'Cấp bậc',
                    },
                    {
                        key: 'chair_user',
                        value: 'Loại ghế theo cấp bậc',
                    },
                    {
                        key: 'chair',
                        value: 'Loại ghế đã đăng ký',
                    },
                ]
                const payload = this.$route.query
                this.$store.dispatch(EXPORT_USER_SEATING, payload).then((res) => {
                    this.is_export_excel = false
                    if (res.error) {
                        this.$bvToast.toast(res.data.message, {
                            title: 'Export excel',
                            variant: 'danger',
                            solid: true
                        });
                    } else {
                        console.log(res.data, 'res.data')
                        exportExcel(HEADER_ROW_EXPORT, res.data, "Danh sách đăng ký.xlsx", true)
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
